import translate from "translate";

translate.engine = "google";

export const translateText = async (text, isArabic) => {
  try {
    if (!isArabic || !text) return text;

    return await translate(text, {
      to: "ar",
    });
  } catch (err) {
    console.log("Translation Error:", err);
    return text;
  }
};